import { ASSET_SERVER, CURRENT_VERSION } from "../../../config/env"
import { compareVersion } from "../../../util/compareVersion"

export interface UpdateInfo {
    version: string // 0.0.1
    releaseTime: string // 2025-09-03T12:00:00Z
    changeLog: {
        [locale: string]: string // "zh-cn": "changelog/V1.0.0.zh-cn.md"
    }
    redirectUrl: string // 跳转链接, 用于跳转官网下载
    downloadUrl?: string // 下载链接, 用于启动平台内部下载
    beta?: { // 测试版, 用于手动点击更新
        version: string // 0.0.1
        releaseTime: string // 2025-09-03T12:00:00Z
        changeLog: {
            [locale: string]: string // "zh-cn": "changelog/V1.0.0.zh-cn.md"
        }
        redirectUrl: string // 跳转链接, 用于跳转官网下载
        downloadUrl?: string // 下载链接, 用于启动平台内部下载
    }
}

const releasesUrl = `${ASSET_SERVER}/releases`

function checkUpdate(updateData: Omit<UpdateInfo, "beta">): Omit<UpdateInfo, "beta">|null {
    // 是否大于当前版本
    if (compareVersion(updateData.version, CURRENT_VERSION) !== 1) return null

    // todo: 是否属于更新地区

    // todo: 当前版本是否在更新范围内

    // todo: 是否命中灰度


    // 将changeLog替换成完整链接
    Object.keys(updateData.changeLog).forEach(key => {
        updateData.changeLog[key] = `${releasesUrl}/${updateData.changeLog[key]}`
    })
    return updateData;
}

export const useUpdate = () => {
    const getUpdateInfo = async (beta: boolean = false): Promise<Omit<UpdateInfo, "beta">|null> => {
        // 获取更新json
        const response = await fetch(`${releasesUrl}/mindplus-update-win.json`, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache', // 防止缓存
                'Pragma': 'no-cache'         // 兼容旧版HTTP
            }
        })
        const updateData = await response.json()

        // 判断是否符合更新条件
        // 手动更新, 先获取测试版
        if (beta && updateData.beta) {
            const ret = checkUpdate(updateData.beta);
            if (ret) return ret;
        }
        return checkUpdate(updateData);
    }

    return {
        getUpdateInfo, // 获取更新内容
    }
}